import { AitCellData } from "./AitCellData";
import { AitRowGroupData } from "./AitRowGroupData";
import { newCell } from "./newCell";
import { newRow } from "./newRow";

/**
 * Add newRowGroupTemplate to existing body.
 *
 * @param defaultCellWidth - The default width for table cells
 * @param blank - The blank value to initialize empty cells with
 * @param rowLength - Length of row
 * @param newRowGroupTemplate - The template to use for creating new row groups
 * @param columnIds - Array of columnIds to use for cells (optional, will generate if not provided)
 * @returns New row group
 */
export const newRowGroup = <T>(
  defaultCellWidth: number,
  blank: T,
  rowLength: number,
  newRowGroupTemplate?: AitRowGroupData<T>,
  columnIds?: string[],
): AitRowGroupData<T> => {
  // Generate columnIds if not provided
  const finalColumnIds = columnIds ?? Array.from({ length: rowLength }, () => crypto.randomUUID());

  return {
    aitid: crypto.randomUUID(),
    replacements: newRowGroupTemplate?.replacements ?? [],
    rows: newRowGroupTemplate?.rows.map((row) => {
      const newCells: AitCellData<T>[] = [];
      for (let ci = 0; ci < rowLength; ci++) {
        newCells.push(
          row.cells[ci] !== undefined
            ? { ...row.cells[ci], aitid: crypto.randomUUID() }
            : newCell(defaultCellWidth, blank, finalColumnIds[ci]),
        );
      }
      return {
        aitid: crypto.randomUUID(),
        cells: newCells,
        coreTrafficLight: "BlankNotEvaluated",
      };
    }) ?? [newRow(defaultCellWidth, blank, rowLength, finalColumnIds)],
    spaceAfter: true,
    coreTrafficLight: "BlankNotEvaluated",
  };
};
